import { NavLink } from "react-router-dom"
import MoreData from "./MoreData"

const More = () => {
    return (
        <>
            <div className="row">
                {MoreData.map(each => (
            
                    <NavLink to={each.Link} className="col-6 col-md-4">
                        <div className="more-section my-3 ">
                            <img src={each.Img} width="60px" alt="your Image" />
                        </div>
                    </NavLink>

                ))}
            </div>
        </>
    )
}
export default More
